const normalizeLabel = (value, fallback) => String(value || fallback).trim();

export const capitalizeReportLabel = (value, fallback = '') => {
  const label = normalizeLabel(value, fallback);
  return label ? `${label.charAt(0).toLocaleUpperCase()}${label.slice(1)}` : label;
};

export const isReportGeographyVisible = (value) => {
  const geography = String(value || '').trim();
  const normalized = geography.toLowerCase();

  return Boolean(geography)
    && !/^\d+$/.test(geography)
    && normalized !== 'unmapped'
    && !normalized.includes('unorganized');
};

export const buildServiceCityMatrix = (sourceRows = []) => {
  const services = new Map();
  const cityTotals = new Map();

  sourceRows.forEach((row) => {
    const city = normalizeLabel(row.city, 'Unmapped');
    if (!isReportGeographyVisible(city)) return;

    const category = normalizeLabel(row.category, 'Uncategorized');
    const subcategory = normalizeLabel(row.subcategory, 'Not mapped');
    const service = normalizeLabel(row.service, 'Unknown Service');
    const experts = Number(row.expertsAddingServices || 0);
    const registrations = Number(row.servicesAdded || 0);
    const serviceKey = JSON.stringify([category, subcategory, service]);

    if (!services.has(serviceKey)) {
      services.set(serviceKey, {
        rank: Number(row.rank || Number.MAX_SAFE_INTEGER),
        category,
        subcategory,
        service,
        expertCounts: {},
        registrationCounts: {},
      });
    }

    const serviceRow = services.get(serviceKey);
    serviceRow.rank = Math.min(serviceRow.rank, Number(row.rank || Number.MAX_SAFE_INTEGER));
    serviceRow.expertCounts[city] = (serviceRow.expertCounts[city] || 0) + experts;
    serviceRow.registrationCounts[city] = (serviceRow.registrationCounts[city] || 0) + registrations;
    cityTotals.set(city, (cityTotals.get(city) || 0) + experts);
  });

  const cities = [...cityTotals.keys()].sort((first, second) => {
    const firstIsNcr = first === 'Delhi NCR';
    const secondIsNcr = second === 'Delhi NCR';
    if (firstIsNcr !== secondIsNcr) return firstIsNcr ? -1 : 1;
    return (cityTotals.get(second) || 0) - (cityTotals.get(first) || 0)
      || first.localeCompare(second, 'en', { sensitivity: 'base' });
  });

  const rows = [...services.values()]
    .sort((first, second) => (
      first.category.localeCompare(second.category, 'en', { sensitivity: 'base' })
      || first.subcategory.localeCompare(second.subcategory, 'en', { sensitivity: 'base' })
      || first.rank - second.rank
      || first.service.localeCompare(second.service, 'en', { sensitivity: 'base' })
    ))
    .map((serviceRow) => {
      const matrixRow = {
        category: serviceRow.category,
        subcategory: serviceRow.subcategory,
        service: serviceRow.service,
      };
      cities.forEach((city, index) => {
        matrixRow[`city_${index}`] = serviceRow.expertCounts[city] || 0;
      });
      return matrixRow;
    });

  return { cities, rows };
};
